"use client"
import React from "react";
import { Container } from "@/components/Container";
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/24/solid";

export const Faq = ({strings}: any): JSX.Element => {

  const t = (key: string): string | React.ReactNode => {
    const splittedKey = key.split(".");        
    return <>{strings["Home"][splittedKey[0]]}</>;
  }

  return (
    <Container className="!p-0">
      <div className="w-full max-w-2xl p-2 mx-auto rounded-2xl">
        {faqdata.map((item, index) => (
          <div key={item.question} className="mb-5">
            <Disclosure>
              {({ open }) => (
                <>
                  <DisclosureButton className="flex items-center justify-between w-full px-4 py-4 text-lg text-left text-gray-800 rounded-lg bg-gray-50 hover:bg-gray-100 focus:outline-none focus-visible:ring focus-visible:ring-indigo-100 focus-visible:ring-opacity-75 dark:bg-trueGray-800 dark:text-gray-200">
                    <span>
                      {t(`${item.question}`)}
                    </span>
                    <ChevronUpIcon
                      className={`${
                        open ? "transform rotate-180" : ""
                      } w-5 h-5 text-indigo-500`}
                    />
                  </DisclosureButton>
                  <DisclosurePanel className="px-4 pt-4 pb-2 text-gray-500 dark:text-gray-300">
                    {t(`${item.answer}`)}                    
                  </DisclosurePanel>
                </>
              )}
            </Disclosure>
          </div>
        ))}
      </div>
    </Container>
  );
}

const faqdata = [
  {
    question: "faq_1_question",
    answer: "faq_1_answer",
  },
  {
    question: "faq_2_question",
    answer: "faq_2_answer",
  },
  {
    question: "faq_3_question",
    answer:
      "faq_3_answer",
  },
  {
    question: "faq_4_question",
    answer: "faq_4_answer"
  },
];
